"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _theme = require("@/assets/js/theme.js");
var _vue = _interopRequireDefault(require("vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      drawer: false,
      direction: "rtl",
      colordiscList: [{
        color: "#409EFF",
        //进入默认选中的查找数据,
        asideBack: "#ecf5ff",
        text: "拂曉藍",
        isshow: true
      }, {
        color: "#5f80c7",
        //进入默认选中的查找数据
        text: "薄暮",
        isshow: false
      }, {
        color: "#faad14",
        //进入默认选中的查找数据
        text: "日暮",
        isshow: false
      }, {
        color: "#f5686f",
        //进入默认选中的查找数据
        text: "火山",
        isshow: false
      }, {
        color: "#9266f9",
        //进入默认选中的查找数据
        text: "醬紫",
        isshow: false
      }, {
        color: "#2bccce",
        //进入默认选中的查找数据
        text: "明青",
        isshow: false
      }, {
        color: "#33cc99",
        //进入默认选中的查找数据
        text: "極光綠",
        isshow: false
      }, {
        color: "#32a2d4",
        //进入默认选中的查找数据
        text: "極客藍",
        isshow: false
      }],
      headerthreme: "",
      clickheader: "" //点击的是哪个类型
    };
  },
  mounted: function mounted() {
    if (sessionStorage.getItem("threme-color")) {
      this.colordiscList.filter(function (item) {
        if (item.color !== sessionStorage.getItem("threme-color")) {
          //返回键名(key)对应的值(value)
          item.isshow = false;
        } else {
          item.isshow = true;
        }
      });
    }
  },
  methods: {
    drawerShow: function drawerShow() {
      this.drawer = true;
    },
    handleClose: function handleClose(done) {
      var _this = this;
      this.$confirm("确认关闭？").then(function (_) {
        done();
      }).catch(function (_) {
        _this.drawer = true;
      });
    },
    handelcolordisc: function handelcolordisc(index, item) {
      this.colordiscList.filter(function (i) {
        if (i.isshow === true) {
          i.isshow = false;
          item.isshow = true;
        }
      });
      sessionStorage.setItem('threme-color', item.color);
      sessionStorage.setItem('threme-aside', item.asideBack);
      sessionStorage.setItem("threme-tabfontcolor", '#000');
      (0, _theme.setTheme)("headerthreme", item.color, item.asideBack);
    }
  }
};